import React, { forwardRef, useState } from 'react'
import fu from "../../images/fu.jpeg";
import drkotru from "../../images/drkotru.jpeg";
import gurpreetKotli from "../../images/gurpreetKotli.png";
import ielts from "../../images/ielts.jpeg";
import igtv from "../../images/igtv.jpeg";
import news from "../../images/news.jpeg";
import recode7 from "../../images/recode7.jpeg";
//import seoWeb1 from "../../images/service-icon-01.png";
import seoWeb from "../../images/services-image.jpg";
import onlineAds from "../../images/services-image-02.jpg";
import poster from "../../images/services-image-03.jpg";
import web from "../../images/services-image-04.jpg";
import video from "../../images/services-image-05.png";
import { Link } from 'react-router-dom';
import DataService from '../../services/data.service';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Content = () => {
    const [successOpen, setSuccessOpen] = useState(false);
    const [failOpen, setFailOpen] = useState(false);
    const [url, setUrl] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const formType = 'getQuote';

    const handleClose = (event, reason) => {
        setSuccessOpen(false);
        setFailOpen(false);
    };

    const sendtomailweb = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('webUrl', url);
        data.append('email', email);
        data.append('formType', formType);

        DataService.sendMail(data)
            .then((response) => {
                if (response.message === 'success') {
                    setSuccessOpen(true);
                    setLoading(false);
                }
                else {
                    setFailOpen(true);
                    setLoading(false);
                }
                setUrl("");
                setEmail("");
            })
    }

    return (
        <div>
            <Snackbar open={successOpen} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                </Alert>
            </Snackbar>
            <Snackbar open={failOpen} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }} >
                    This is a warning message!
                </Alert>
            </Snackbar>
            <div class="client-slider">
                <div class="slide-track2">
                    <div class="client-slide">
                        <img src={fu} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={gurpreetKotli} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={news} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={drkotru} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={igtv} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={ielts} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={recode7} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>


                    <div class="client-slide">
                        <img src={fu} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={gurpreetKotli} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={news} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={drkotru} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={igtv} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={ielts} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={recode7} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>


                    <div class="client-slide">
                        <img src={fu} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={gurpreetKotli} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={news} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={drkotru} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={igtv} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={ielts} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                    <div class="client-slide">
                        <img src={recode7} alt="Frishtey Media" className='align-self-center p-2' />
                    </div>
                </div>
            </div>


            <div id="free-quote" class="free-quote">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 offset-lg-4">
                            <div class="section-heading  wow fadeIn" data-wow-duration="1s" data-wow-delay="0.3s">
                                <h6>Get Your Free Quote</h6>
                                <h4>Grow With Us Now</h4>
                                <div class="line-dec"></div>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2  wow fadeIn" data-wow-duration="1s" data-wow-delay="0.8s">
                            <form id="search" onSubmit={sendtomailweb} >
                                <div class="row">
                                    <div class="col-lg-4 col-sm-4">
                                        <fieldset>
                                            <input type="text" name="weburl" id="weburl" class="website" placeholder="Website URL..." autocomplete="on" required
                                                value={url} onChange={e => setUrl(e.target.value)} />
                                        </fieldset>
                                    </div>
                                    <div class="col-lg-4 col-sm-4">
                                        <fieldset>
                                            <input type="text" name="uemail" id="uemail" class="email" placeholder="Email Address..." autocomplete="on" required
                                                value={email} onChange={e => setEmail(e.target.value)} />
                                        </fieldset>
                                    </div>
                                    <div class="col-lg-4 col-sm-4">
                                        <fieldset>
                                            {
                                                loading ?
                                                    <button type="submit" class="main-button" disabled>
                                                        <span className="spinner-border spinner-border-sm"></span>&nbsp;
                                                        Loading...
                                                    </button>
                                                    :
                                                    <button type="submit" class="main-button">
                                                        Get Quote Now
                                                    </button>
                                            }
                                        </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            {/* Services */}
            <div id="services" class="services section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
                                <h6>Our Services</h6>
                                <h4>What Frishtey <em>Provides</em></h4>
                                <div class="line-dec"></div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="naccs">
                                <div class="grid">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <ul class="nacc">
                                                <li class="active" style={{ padding: '10px' }}>
                                                    <div class="col-lg-12 align-self-center">
                                                        <Link to="/services/seo-and-web-analytics">
                                                            <img src={seoWeb} alt="" />
                                                        </Link>
                                                        <div class="left-text">
                                                            <Link to="/services/seo-and-web-analytics">
                                                                <h4 className='text-center'>SEO Analysis &amp; Daily Reports</h4>
                                                            </Link>
                                                            <p className='text-center fw-normal'>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-4">
                                            <ul class="nacc">
                                                <li class="active" style={{ padding: '10px' }}>
                                                    <div class="col-lg-12 align-self-center">
                                                        <Link to="/services/online-advertisement">
                                                            <img src={onlineAds} alt="" />
                                                        </Link>
                                                        <div class="left-text">
                                                            <Link to="/services/online-advertisement">
                                                                <h4 className='text-center'>Online Advertisement</h4>
                                                            </Link>
                                                            <p className='text-center fw-normal'>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-4">
                                            <ul class="nacc">
                                                <li class="active" style={{ padding: '10px' }}>
                                                    <div class="col-lg-12 align-self-center">
                                                        <Link to="/services/poster-and-logo-design">
                                                            <img src={poster} alt="" />
                                                        </Link>
                                                        <div class="left-text">
                                                            <Link to="/services/poster-and-logo-design">
                                                                <h4 className='text-center'>Poster &amp; Logo Design</h4>
                                                            </Link>
                                                            <p className='text-center fw-normal'>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-4">
                                            <ul class="nacc">
                                                <li class="active" style={{ padding: '10px' }}>
                                                    <div class="col-lg-12 align-self-center">
                                                        <Link to="/services/web-design-and-development">
                                                            <img src={web} alt="" style={{ height: '250px' }} />
                                                        </Link>
                                                        <div class="left-text">
                                                            <Link to="/services/web-design-and-development">
                                                                <h4 className='text-center'>Web Design & Development</h4>
                                                            </Link>
                                                            <p className='text-center fw-normal'>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-4">
                                            <ul class="nacc">
                                                <li class="active" style={{ padding: '10px' }}>
                                                    <div class="col-lg-12 align-self-center">
                                                        <Link to="/services/video-editing-and-animation">
                                                            <img src={video} alt="" style={{ height: '250px' }} />
                                                        </Link>
                                                        <div class="left-text">
                                                            <Link to="/services/video-editing-and-animation">
                                                                <h4 className='text-center'>Video Editing &amp; Animation</h4>
                                                            </Link>
                                                            <p className='text-center fw-normal'>We have been actively providing local & Globally search engine optimization services that help, businesses achieve the desired  search results. We develop local & Globally SEO strategies that are flexible for businesses and budgets of all sizes..</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
